import React from "react";

export const AppInput = ({
  label,
  className,
  isRequired = false,
  ...attrs
}) => {
  const { id } = attrs;
  return (
    <div className={className}>
      <label htmlFor={id} className="flex mb-2 font-bold">
        {label}
        {isRequired && (
          <div className="translate-y-1">
            <sup className="text-lg text-canton-jadesheen">*</sup>
          </div>
        )}
      </label>
      <input
        id={id}
        className="w-full border border-sapphire bg-transparent py-3 px-4 text-night-blue outline-none"
        {...attrs}
      />
    </div>
  );
};
